module.exports = __webpack_public_path__ + "static/media/26.ab930a1c.mp3";